export default __webpack_public_path__ + "static/media/btn_promo.603f833d.png";